import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=6cb3fe23&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb3fe23')) {
      api.createRecord('6cb3fe23', component.options)
    } else {
      api.reload('6cb3fe23', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=6cb3fe23&", function () {
      api.rerender('6cb3fe23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Badge.vue"
export default component.exports